import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import StringField from '../../../../_common/platform/tsx/StringField';
import DateField from '../../../../_common/platform/tsx/DateField';
import NumberField from '../../../../_common/platform/tsx/NumberField';
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import { CHART_STRIPS } from '../chartConstants';
import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import { IParameterFieldBaseOptions } from '../../../../_common/platform/ts/ParameterFieldBase';
import { ChartPropsManager } from '../ChartPropsManager';

//LL: 28.05.20: StandardInheritanceFlag - when with standard inheritance, on upper levels. See ChartAxisField_inThemes
//var StandardInheritanceFlag = true;  // my flag

class ChartBreaksFieldRow extends React.Component<
    {
        value?;
        values?;
        index?: number;
        forActualChart?: boolean;
        themeObj?: appTheme.IValuesCollection;
        glob: IGlob;

        onChange(value, index: number): void;
        onRemove?(index: number): void;
    },
    {}
> {
    private references: {
        type?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);
    }

    normalize(value) {
        if (value.type == null) {
            delete value.startValue;
            delete value.endValue;
            delete value.name;
            return;
        }
    }

    processTypeChange = (e) => {
        let val = (this.references.type as HTMLInputElement).value;

        //LL: 27.05.20: for inheritance, for clearElem -> null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});

        if (val === 'none' || val == null) {
            delete obj.type;
        } else {
            obj.type = val;
        }

        this.handleValueChange(obj);
    };

    processStartValueChange_N = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.startValue;
        } else {
            obj.startValue = val;
        }
        this.handleValueChange(obj);
    };

    processStartValueChange_Float = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.startValue;
        } else {
            obj.startValue = val;
        }
        this.handleValueChange(obj);
    };

    processStartValueChange_Date = (val) => {
        //LL:  numeric or date - depends on DataType.  Message !
        let notDate = false;
        if (val === '' || val == null) {
            //val = null;
        } else {
            let date = Date.parse(val);
            if (isNaN(date)) {
                val = null;
                notDate = true;
            }
        }

        if (notDate) {
            alert('processStartValueChange: value must be Date');
            return;
        }

        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.startValue;
        } else {
            obj.startValue = val;
        }
        this.handleValueChange(obj);
    };

    processStartValueChange_Time = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.startValue;
        } else {
            obj.startValue = val;
        }
        this.handleValueChange(obj);
    };
    processEndValueChange_Time = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.endValue;
        } else {
            obj.endValue = val;
        }
        this.handleValueChange(obj);
    };

    processEndValueChange_N = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.endValue;
        } else {
            obj.endValue = val;
        }
        this.handleValueChange(obj);
    };

    processEndValueChange_Float = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.endValue;
        } else {
            obj.endValue = val;
        }
        this.handleValueChange(obj);
    };

    processEndValueChange_Date = (val) => {
        //LL:  numeric or date - depends on DataType.  Message !
        let notDate = false;
        if (val === '' || val == null) {
            //val = null;
        } else {
            let date = Date.parse(val);
            if (isNaN(date)) {
                val = null;
                notDate = true;
            }
        }

        if (notDate) {
            alert('processEndValueChange: value must be Date');
            return;
        }

        let obj = _.clone(this.props.value || {});
        if (val === '' || val == null) {
            delete obj.endValue;
        } else {
            obj.endValue = val;
        }
        this.handleValueChange(obj);
    };

    handleValueChange(value) {
        this.normalize(value);

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.index);
        }
    }

    handleRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.index);
        }
    };

    getRemoveButton(value) {
        if (value.type == null) {
            return;
        }

        if (value.inherited === true) {
            return <span className="glyphicon glyphicon-arrow-down"></span>;
        }

        return <span className="glyphicon glyphicon-remove" onClick={this.handleRemove}></span>;
    }

    //LL: must have "name"
    processNameChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.name = val;
        this.handleValueChange(obj);
    };

    processEmptyNameClick(e) {
        e.stopPropagation();
        e.preventDefault();
    }

    //LL: must have "name"
    getName(value) {
        if (value.type == null) {
            return;
        }
        //LL: 19.11.20: Problem:
        //  In this case <td> will have class "cell-name ui-sortable-handle"
        //                 (is assigned in $(tableBody).sortable, handle: "cell-name")
        //  And it causes the behaviour: clicking on this field does not issue onBlur for currently edited <input>
        //  -------------------------
        //  For example: DiscreteMappingField.tsx, etc are without such problem, they have no "sortable".
        //  But ConstLines, Strips are similar and have this problem
        //  -------------------------
        //  So, either remove "sortable", which is not very much needed,
        //      or create some dummy field inside
        //  ----------------------------
        //  Or define:    handle: '.cell-drag',  //LL: 19.11.20     YES !!!

        //LL: backcolor is gray:
        //if (value.type == null) {
        //    return (
        //        <StringField
        //            value={ '' }
        //            readOnly={ true }
        //        />
        //    );
        //};
        //if (value.type == null) {
        //    return (
        //        <span
        //            className="form-control"
        //            onClick={ this.processEmptyNameClick }
        //        />
        //    );
        //};
        //=========================================================

        let displayVal = value.name || '';
        return (
            <StringField
                onChange={this.processNameChange}
                value={displayVal}
                allowNull={false}
                applyOnEnter={true}
                changeOnBlurOnly={true}
            />
        );
    }

    getType(value) {
        let displayVal = value.type || 'none';

        //LL:  "secondaryAxisArr" not needed here, breaks are not applied to them
        let arr = CHART_STRIPS.stripType.slice(0); // ['arguments', 'values']
        //LL: 03.06.20:  add 'not used' type => will not used in Chart
        arr.push(CHART_STRIPS.notUsedType);

        let options = _.map(arr, function (value) {
            return (
                <option key={value} value={value}>
                    {value}
                </option>
            );
        });

        //LL: 03.06.20: show 'none' only when no value
        let noneOption;
        if (displayVal === 'none') {
            noneOption = (
                <option key="none" value="none" disabled={true}>
                    none
                </option>
            );
        }

        return (
            <select
                ref={(input) => {
                    this.references.type = input;
                }}
                className="form-control"
                onChange={this.processTypeChange}
                value={displayVal}
            >
                {noneOption}
                {options}
            </select>
        );
    }

    //LL: with NEW
    getAxisType(value) {
        if (value.type == null) {
            return;
        }

        let props_values = this.props.values;
        let axisName = value.type;
        let axisType = ChartPropsManager.getAxisType(props_values, axisName, this.props.themeObj);

        const defName = 'automatic'; // "default"

        if (axisType == null) {
            axisType = defName;
        }

        let emphasize = false;

        if (axisType === 'discrete' || axisType === defName) {
            emphasize = true;
        }

        let style1: any = {};

        if (emphasize) {
            style1.color = '#1111ee';
        }

        return <span style={style1}>{axisType}</span>;
    }

    getDataType(value) {
        if (!this.props.forActualChart) {
            return { type: 'i', timePart: null };
        }

        let props_values = this.props.values;

        let axisName = value.type;

        if (axisName === 'arguments') {
            return ChartPropsManager.get_argumentAxis_DataType_withTimePart(props_values, this.props.glob);
        } else if (axisName === 'values') {
            return ChartPropsManager.get_valueAxis_DataType_withTimePart(props_values, this.props.glob);
        }
        //LL: 03.06.20:  add 'not used' type => will not used in Chart
        else if (axisName === CHART_STRIPS.notUsedType) {
            return { type: 'i', timePart: null };
        }

        return undefined;
    }

    _get_defaultDate() {
        let d = new Date(Date.now());
        d.setHours(0, 0, 0, 0);
        return d;
    }

    getStartValue(value, dataType) {
        if (value.type == null) {
            return;
        }

        let displayVal = value.startValue; // allowNull

        switch (dataType) {
            case 'i':
                return (
                    <NumberField
                        value={displayVal}
                        allowNull={true}
                        applyOnEnter={true}
                        integer={true}
                        onChange={this.processStartValueChange_N}
                    />
                );

            case 'r':
                return (
                    <NumberField
                        value={displayVal}
                        allowNull={true}
                        applyOnEnter={true}
                        integer={false}
                        onChange={this.processStartValueChange_Float}
                    />
                );

            case 'datetime':
            case 'date':
                displayVal = value.startValue; //LL:  empty value - OK
                let hint = value.startValue == null ? 'not set, default' : value.startValue.toString();
                return <DateField value={displayVal} hint={hint} onChange={this.processStartValueChange_Date} />;

            case 'time': //LL: 22.11.20
                displayVal = value.startValue; //LL:  empty value - OK
                let hintT = value.startValue == null ? 'not set, default' : value.startValue.toString();
                return (
                    <DateField
                        type="time"
                        value={displayVal}
                        hint={hintT}
                        onChange={this.processStartValueChange_Time}
                    />
                );

            default:
                return;
        }
    }

    getEndValue(value, dataType) {
        if (value.type == null) {
            return;
        }

        let displayVal = value.endValue; // allowNull

        switch (dataType) {
            case 'i':
                return (
                    <NumberField
                        value={displayVal}
                        allowNull={true}
                        applyOnEnter={true}
                        integer={true}
                        onChange={this.processEndValueChange_N}
                    />
                );

            case 'r':
                return (
                    <NumberField
                        value={displayVal}
                        allowNull={true}
                        applyOnEnter={true}
                        integer={false}
                        onChange={this.processEndValueChange_Float}
                    />
                );

            case 'datetime':
            case 'date':
                displayVal = value.endValue; //LL:  empty value - OK
                let hint = value.endValue == null ? 'not set, default' : value.endValue.toString();
                return <DateField value={displayVal} hint={hint} onChange={this.processEndValueChange_Date} />;

            case 'time': //LL: 22.11.20
                displayVal = value.endValue; //LL:  empty value - OK
                let hintT = value.endValue == null ? 'not set, default' : value.endValue.toString();
                return (
                    <DateField type="time" value={displayVal} hint={hintT} onChange={this.processEndValueChange_Time} />
                );

            default:
                return;
        }
    }

    render() {
        const value = this.props.value || {};
        //LL: same as in ChartAxisField:
        const dataTypeExt = this.getDataType(value);

        let dataType;
        let dataTypePure;
        let dataTimePart;

        //dataType = dataTypeExt.type;
        //if (dataTypeExt.timePart != null) {
        //    dataType = dataTypeExt.timePart;
        //}
        //dataTypePure = dataTypeExt.type;
        //dataTimePart = dataTypeExt.timePart;

        if (dataTypeExt != null) {
            dataType = dataTypeExt.type;

            if (dataTypeExt.timePart != null && dataTypeExt.timePart !== 'none') {
                dataType = dataTypeExt.timePart;
            }

            dataTypePure = dataTypeExt.type;
            dataTimePart = dataTypeExt.timePart;
        } else {
            dataType = 's';
            dataTypePure = 's';
        }

        //LL: 03.06.20:   must have "name"   className="cell-name"
        //let tdName =
        //    <td className="cell-name">
        //        { this.getName(value) }
        //    </td>;
        //LL: 19.11.20:  //handle: '.cell-drag' in $(tableBody).sortable
        //    See problem description in getName
        let nameElem = this.getName(value);
        let nameClass = 'cell-name';
        if (nameElem != null) {
            nameClass += ' cell-drag';
        }
        let tdName = <td className={nameClass}>{nameElem}</td>;

        return (
            <tr>
                <td className="cell-remove">{this.getRemoveButton(value)}</td>
                {tdName}
                <td className="cell-type">{this.getType(value)}</td>
                <td className="cell-axisType">{this.getAxisType(value)}</td>
                <td className="cell-startValue">{this.getStartValue(value, dataTypePure)}</td>
                <td className="cell-endValue">{this.getEndValue(value, dataTypePure)}</td>
            </tr>
        );
    }
}

export interface IChartBreaksFieldOptions extends IParameterFieldBaseOptions {
    widgetTypeName?: string;
    widgetValues?;
}

export default class ChartBreaksField extends React.Component<
    {
        value: any[];
        border: boolean;
        options: IChartBreaksFieldOptions;
        themeObj: appTheme.IValuesCollection;
        glob: IGlob;

        onChange(value: any[]): void;
    },
    { forActualChart: boolean }
> {
    private references: {
        tableBody?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        let forActualChart = true; //LL: 28.05.20  false when with standard inheritance, on upper levels
        let props_values = this.get_props_values();

        if (props_values == null) {
            forActualChart = false; //LL: 28.05.20: when with standard inheritance, on upper levels
        }

        this.state = {
            forActualChart: forActualChart
        };
    }

    private startIndex;

    reorderStart = (e, ui) => {
        this.startIndex = $(ui.item).index();
    };

    reorderStop = (e, ui) => {
        if (this.startIndex == null) {
            return;
        }

        let startIndex = this.startIndex;
        let stopIndex = $(ui.item).index();

        this.startIndex = null;

        //LL: see: https://gist.github.com/avakhov/7b9d2b1a354e59dbfa63
        //   Вызываем cancel, чтобы элементы местами поменял React.js
        //   $(me.getDOMNode()).sortable("cancel");
        let tableBody = this.references.tableBody;
        $(tableBody).sortable('cancel');

        this.processReorder(startIndex, stopIndex);
    };

    componentDidMount() {
        let tableBody = this.references.tableBody;

        $(tableBody).sortable({
            axis: 'y',
            forceHelperSize: true,
            items: 'tr:not(.empty)',
            opacity: 0.8,
            //handle: '.cell-name',
            handle: '.cell-drag', //LL: 19.11.20: in addition to cell-name
            cursor: 'grabbing',
            start: this.reorderStart,
            stop: this.reorderStop
        });
    }

    componentWillUnmount() {
        let tableBody = this.references.tableBody;
        $(tableBody).sortable('destroy');
    }

    processReorder(start, stop) {
        if (start === stop) {
            return;
        }

        let value = this.props.value.slice(0);

        let item = value.splice(start, 1);
        value.splice(stop, 0, item[0]);

        this.handleValueChange(value);
    }

    handleValueChange(value) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    addRow = (obj) => {
        let arr = this.props.value.slice(0);

        arr.push(obj);
        this.handleValueChange(arr);
    };

    handleOnChangeRow = (obj, i) => {
        let arr = this.props.value.slice(0);
        let prev = arr.splice(i, 1, obj)[0];
        this.handleValueChange(arr);
    };

    handleOnRemoveRow = (i) => {
        let arr = this.props.value.slice(0);
        arr.splice(i, 1);
        this.handleValueChange(arr);
    };

    get_props_values() {
        let pv;

        if (this.props.options != null && this.props.options.widgetValues != null) {
            if (this.props.options.widgetTypeName === 'pdc-widget-chart') {
                pv = this.props.options.widgetValues;
            }
        }
        return pv;
    }

    getChartAxisArrayField() {
        let props_values = this.get_props_values();

        if (props_values == null) {
            return [];
        }

        const chartAxisArrayFieldValue = ChartPropsManager.getChartAxisArray(props_values, this.props.themeObj);

        return chartAxisArrayFieldValue;

        //let ChartAxisArrayFieldName = 'ChartAxisArrayField';   //  TO DO  <===================
        //if ((this.props.options != null) &&
        //    (typeof this.props.options.ChartAxisArrayFieldName === 'string')) {
        //    ChartAxisArrayFieldName = this.props.options.ChartAxisArrayFieldName;
        //}
        //
        //let ChartAxisArrayField = [];
        //if (props_values != null) {
        //    if (props_values[ChartAxisArrayFieldName] != null)
        //        ChartAxisArrayField = props_values[ChartAxisArrayFieldName];
        //}
        //else {
        //    alert('LL: ChartBreaksField _getChartAxisArrayField: props_values is null. Wrong platform version');
        //}
        //return ChartAxisArrayField;
    }

    callEvalAuxAxisNames(chartAxisArrayField) {
        const result = ChartPropsManager.evalAuxAxisNames(chartAxisArrayField);

        return result;
    }

    render() {
        let forActualChart = this.state.forActualChart; // false - when with standard inheritance, on upper levels
        let props_values = this.get_props_values();
        // if (props_values == null) {
        //     //return null;
        //     //LL: 28.05.20:
        //     //if (!StandardInheritanceFlag) {  // as old
        //     //    return null;
        //     //}
        // }

        //LL: 14.06.19:  "secondaryAxisArr" not needed here, breaks are not applied to them
        //    BUT:  "multiAxis" is needed - for warning note    Now always !
        let secondaryAxisArr = [];
        let ChartAxisArrayField = this.getChartAxisArrayField();
        let AuxAxisNames = this.callEvalAuxAxisNames(ChartAxisArrayField);

        if (AuxAxisNames != null && AuxAxisNames != '') {
            secondaryAxisArr = AuxAxisNames.split(';');
        }
        //let multiAxis = secondaryAxisArr.length > 0;
        //LL: "optionThemeOwnAndParent" is from ThemeField.tsx  EditComponentDepsWrapper.render:
        let objThemeOwnAndParent = appTheme.getThemeOwnAndParentvalues(this.props);
        let ownValues = objThemeOwnAndParent.ownValues;
        let parentValues = objThemeOwnAndParent.parentValues;

        let rows = _.map(this.props.value, (obj, index) => {
            let obj2: any = appTheme.setProperInheritedFlag(obj, ownValues, parentValues, 'ChartStripsField_inThemes');
            //LL: may be null, if just removed
            if (obj2 == null) {
                return null;
            }

            return (
                <ChartBreaksFieldRow
                    key={index + '-' + obj2.type}
                    index={index}
                    //empty={true}
                    value={obj2}
                    forActualChart={forActualChart}
                    values={props_values}
                    glob={this.props.glob}
                    themeObj={this.props.themeObj}
                    onChange={this.handleOnChangeRow}
                    onRemove={this.handleOnRemoveRow}
                />
            );
        });

        let stylingMsg = (
            <em
                style={{
                    display: 'block',
                    paddingLeft: '6px',
                    marginTop: '6px',
                    marginBottom: '10px'
                }}
            >
                {'Styling Options are defined on "Value Axis" and "Argument Axis" pages'}
            </em>
        );

        let multiAxisMsg = (
            <em
                style={{
                    display: 'block',
                    paddingLeft: '6px',
                    marginTop: '6px',
                    marginBottom: '10px'
                }}
            >
                {'Breaks on "Values" axis are not applied when multi "Value" axes are defined'}
            </em>
        );

        let rangeMsg = (
            <em
                style={{
                    display: 'block',
                    paddingLeft: '6px',
                    marginTop: '6px',
                    marginBottom: '10px'
                }}
            >
                {'Note:  break is visible only if its range exceeds the axis tick interval'}
            </em>
        );

        let discreteMsg = (
            <em
                style={{
                    display: 'block',
                    paddingLeft: '6px',
                    marginTop: '6px',
                    marginBottom: '10px'
                }}
            >
                {'Note:  breaks are not applied to discrete axis'}
            </em>
        );

        //LL: 03.06.20:  must have "name"   className="cell-name"
        let thName = <th className="cell-name">{'Name'}</th>;

        return (
            <div className={'chartbreaks-field'}>
                <div className={'div-container'}>
                    <div className="chartbreaks-field-common"></div>
                    {discreteMsg}
                    {rangeMsg}
                    {multiAxisMsg}
                    {stylingMsg}
                    <table className={'table' + (this.props.border === true ? ' table-bordered' : '')}>
                        <thead>
                            <tr>
                                <th className="cell-remove"></th>
                                {thName}
                                <th className="cell-type">{'Axis'}</th>
                                <th className="cell-axisType">{'Axis Type'}</th>
                                <th className="cell-startValue">{'Start Value'}</th>
                                <th className="cell-endValue">{'End Value'}</th>
                            </tr>
                        </thead>

                        <tbody
                            ref={(input) => {
                                this.references.tableBody = input;
                            }}
                        >
                            {rows}
                            <ChartBreaksFieldRow glob={this.props.glob} onChange={this.addRow} />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
